import { render, staticRenderFns } from "./EmailChangePending.vue?vue&type=template&id=17c75cef&lang=pug"
import script from "./EmailChangePending.vue?vue&type=script&lang=js"
export * from "./EmailChangePending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports